import { createSlice } from '@reduxjs/toolkit';
import { catchmentJourneyGetData } from './catchmntthunk';

const initialState = {
  data: null,          // Pura API response
  loading: false,
  error: null,
  journeys: [],        // Dropdown list
  selectedJourneyId: "", // 👈 Added this to store the selection globally
};

const catchmentSlice = createSlice({
  name: 'catchmentData',
  initialState,
  reducers: {
    // 👈 Action to update the selected ID from the dropdown
    setSelectedJourneyId: (state, action) => {
      state.selectedJourneyId = action.payload;
    },
    clearData: (state) => {
      state.data = null;
      state.error = null;
      state.journeys = [];
      state.selectedJourneyId = "";
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(catchmentJourneyGetData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(catchmentJourneyGetData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;

        const apiData = action.payload?.data;

        if (apiData && Array.isArray(apiData.allWayPoints)) {
          state.journeys = apiData.allWayPoints.map((item) => ({
            journeyId: item.journeyId,
            journeyName: item.journeyName,
            type: item.type,
            startTime: item.interval?.startTime || "N/A",
            endTime: item.interval?.endTime || "N/A",
            encodedPath: item.encodedPath 
          }));
        } else {
          state.journeys = [];
        }
      })
      .addCase(catchmentJourneyGetData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearData, setSelectedJourneyId } = catchmentSlice.actions;
export default catchmentSlice.reducer;